/**
 * API URL Configuration
 * Priority: ENV var > hostname detection > fallback
 */
export const getApiUrl = () => {
  // 1. Check env var first (highest priority)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // 2. Server-side rendering check (for Next.js)
  if (typeof window === 'undefined') {
    return process.env.NEXT_PUBLIC_API_URL || 'https://api.genanything.ai';
  }

  const hostname = window.location.hostname;

  // 3. Hostname-based detection (fallback when no env var)
  if (hostname === 'genanything.ai' || hostname === 'www.genanything.ai') {
    return 'https://api.genanything.ai';
  }

  if (hostname === 'dev.genanything.ai') {
    return 'https://devapi.genanything.ai';
  }

  // Local development fallback
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:5001';
  }

  // Fallback to production
  console.warn(`Unknown hostname: ${hostname}, defaulting to production`);
  return 'https://api.genanything.ai';
};

export const API_URL = getApiUrl();

// Debug logging (only in development)
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  console.log('🔗 API URL:', API_URL);
  console.log('🌐 Hostname:', window.location.hostname);
}
